import * as React from 'react';
import createIconComponent from '../createIconComponent.js';

var l = (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M2.5 12L9 18.5L21.5 5.5", stroke: "#141516", strokeWidth: "1.5" })));
var m = (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M1.66666 7.99996L5.99999 12.3333L14.3333 3.66663", stroke: "#141516" })));
var s = (React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M1.35001 6L4.60001 9.25L10.85 2.75", stroke: "#141516" })));
var Tick = createIconComponent({ s: s, m: m, l: l });

export { Tick as default };
//# sourceMappingURL=Tick.js.map
